// This file is automatically generated. Do not edit manually.

import { DeliveryPackageSource } from "src/api/generated/erp/delivery/model/deliveryPackageSource";
import { DeliveryPackageSourceType } from "src/api/generated/io/aavo/applications/db/erp/types/deliveryPackageSourceType";
import { DeliveryPackageState } from "src/api/generated/erp/db/types/enums/deliveryPackageState";
import { ServerSideDataModelRequest } from "src/api/generated/common/dataGrids/serverSideDataModelRequest";
import { ServerSideDataModelResult } from "src/api/generated/common/dataGrids/serverSideDataModelResult";
import { DeliveryPackageWithSourcesView } from "src/api/generated/erp/db/types/tables/deliveryPackageWithSourcesView";
import { DeliveryPackage } from "src/api/generated/erp/db/types/tables/deliveryPackage";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace DeliveryPackagesDataGridApi {
	export async function getDeliveryPackages(args: {
		source?: DeliveryPackageSource | null | undefined;
		sourceType?: DeliveryPackageSourceType | null | undefined;
		packageState?: Array<DeliveryPackageState>;
		deliveryId?: number | null | undefined;
		onlyPackagesWithoutConnectedDelivery?: boolean;
		deliveryPackageId?: number | null | undefined;
		parentPackageBundleId?: number | null | undefined;
		siteId?: number | null | undefined;
		searchQuery?: string;
		bundleHandling?: DeliveryPackagesDataGridApi_BundleHandling;
		warehouseLocationId?: number | null | undefined;
		createdByUserId?: number | null | undefined;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<DeliveryPackageWithSourcesView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackagesDataGrid/getDeliveryPackages",
			method: "POST",
			data: {
				source: args.source,
				sourceType: args.sourceType,
				packageState: args.packageState,
				deliveryId: args.deliveryId,
				onlyPackagesWithoutConnectedDelivery: args.onlyPackagesWithoutConnectedDelivery,
				deliveryPackageId: args.deliveryPackageId,
				parentPackageBundleId: args.parentPackageBundleId,
				siteId: args.siteId,
				searchQuery: args.searchQuery,
				bundleHandling: args.bundleHandling,
				warehouseLocationId: args.warehouseLocationId,
				createdByUserId: args.createdByUserId,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<DeliveryPackageWithSourcesView>;
	}

	export async function getDeliveryPackagesForCustomer(args: {
		customerId: number;
		packageState?: Array<DeliveryPackageState>;
		deliveryId?: number | null | undefined;
		onlyPackagesWithoutConnectedDelivery?: boolean;
		deliveryPackageId?: number | null | undefined;
		parentPackageBundleId?: number | null | undefined;
		siteId?: number | null | undefined;
		searchQuery?: string;
		bundleHandling?: DeliveryPackagesDataGridApi_BundleHandling;
		warehouseLocationId?: number | null | undefined;
		createdByUserId?: number | null | undefined;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<DeliveryPackageWithSourcesView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackagesDataGrid/getDeliveryPackagesForCustomer",
			method: "POST",
			data: {
				customerId: args.customerId,
				packageState: args.packageState,
				deliveryId: args.deliveryId,
				onlyPackagesWithoutConnectedDelivery: args.onlyPackagesWithoutConnectedDelivery,
				deliveryPackageId: args.deliveryPackageId,
				parentPackageBundleId: args.parentPackageBundleId,
				siteId: args.siteId,
				searchQuery: args.searchQuery,
				bundleHandling: args.bundleHandling,
				warehouseLocationId: args.warehouseLocationId,
				createdByUserId: args.createdByUserId,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<DeliveryPackageWithSourcesView>;
	}

	export async function delete_(args: { deliveryPackages: Array<DeliveryPackage> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackagesDataGrid/delete",
			method: "POST",
			data: {
				deliveryPackages: args.deliveryPackages,
			},
		});
		return response as void;
	}

	export async function getDeliveryPackagesForCargoDriver(args: {
		deliveryId: number;
		searchQuery?: string;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<DeliveryPackageWithSourcesView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackagesDataGrid/getDeliveryPackagesForCargoDriver",
			method: "POST",
			data: {
				deliveryId: args.deliveryId,
				searchQuery: args.searchQuery,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<DeliveryPackageWithSourcesView>;
	}
}

export const DeliveryPackagesDataGridApi_BundleHandlingValues = [
	"ONLY_TOP_LEVEL",
	"ONLY_BUNDLES",
	"ONLY_NON_BUNDLES",
] as const;

export type DeliveryPackagesDataGridApi_BundleHandling =
	(typeof DeliveryPackagesDataGridApi_BundleHandlingValues)[number];
